import { createFileRoute } from '@tanstack/react-router'

import { BackofficeInsuranceCertificateGeneratorRealEstateAgentsPage } from '../../../../../components/pages/backoffice/insurance-certificate-generator/backoffice-insurance-certificate-generator-real-estate-agents-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute(
  '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents',
)({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <BackofficeInsuranceCertificateGeneratorRealEstateAgentsPage />
    </PermissionChecker>
  ),
})
